import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Unlock as UnlockIcon, Lock as LockIcon } from "react-bootstrap-icons";
import PPIService from "../../services/PPIService";
import Loader from "../../components/Loader";

const Settings = ({ cardDetails, fetchCardDetails }) => {
  const [loading, setLoading] = useState(false);

  const cardStatusUpdateHandler = async (cardStatus) => {
    const confirmResult = await Swal.fire({
      title: `Are you sure you want to ${cardStatus.toLowerCase()} the card?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${cardStatus}`,
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    setLoading(true);
    try {
      const result = await PPIService.cardStatusUpdate(cardStatus);

      if (!result.success) {
        Swal.fire(
          "Oops!",
          result.message || "Failed to update status",
          "error"
        );
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        await fetchCardDetails();
        Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // if (loading) return <Loader />;
  return (
    <React.Fragment>
      {cardDetails && (
        <div>
          {cardDetails.card_status === 1 && (
            <button
              className="btn btn-danger w-100 mb-3"
              disabled={loading}
              onClick={() => cardStatusUpdateHandler("Block")}
            >
              <LockIcon className="me-2" /> Block Card
            </button>
          )}

          {cardDetails.card_status === 3 && (
            <button
              className="btn btn-success w-100 mb-3"
              disabled={loading}
              onClick={() => cardStatusUpdateHandler("Unblock")}
            >
              <UnlockIcon className="me-2" /> Unblock Card
            </button>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default Settings;
